import { render, staticRenderFns } from "./TransferConfirmation.vue?vue&type=template&id=609254af&"
import script from "./TransferConfirmation.vue?vue&type=script&lang=js&"
export * from "./TransferConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TransferConfirmation.vue"
export default component.exports